import * as z from "zod";

export const getRivoCustomerLoyalty = {
  name: "getRivoCustomerLoyalty" as const,
  input: z.object({ customerEmail: z.string() }),
  output: z.object({ points: z.number().nullish() }),
};
